const ja_in_risks_page = {
  address: 'アドレス',
  type: 'タイプ',
};
const ja = {
  deposit: 'デポジット',
  Deposit: 'デポジット',
  withdraw: '抽出',
  Withdraw: '抽出',
  swap: 'スワップ',
  Swap: 'スワップ',
  pool: 'プール',
  Pool: 'プール',
  pools: 'プール',
  Pools: 'プール',
  view_pools: 'プールを見る',
  view_pool: 'プールを見る',
  add_token: 'トークンの追加',
  create_new_pool: 'フロープールの作成',
  Create_New_Pool: 'フロープールの作成',
  your_liquidity: 'あなたの流動性',
  Your_Liquidity: 'あなたの流動性',
  farms: 'ファーム',
  Farms: 'ファーム',
  docs: 'ドキュメント',
  account: 'アカウント番号',
  Discord: 'Discord',
  Telegram: 'Telegram',
  Twitter: 'Twitter',
  connect_to_near: 'ウォレットの接続',
  slippage: 'スリッページ',
  minimum_received: '受け取り可能な最低金額',
  swap_rate: '為替レート',
  pool_fee: '取扱手数料',
  balance: 'バランス',
  from: 'から',
  to: 'まで',
  submit: '提出',
  view_account: 'アカウントを見る',
  liquidity: '流動性',
  tokens: 'トークン',
  fee: '手数料',
  fees: '手数料',
  details: '詳細',
  detail: '詳細',
  minimum_tokens_out: '最低限必要なトークン数',
  pair: '取引ペア',
  tvl: 'TVL',
  add_liquidity: '流動性の追加',
  remove_liquidity: '流動性の除去',
  total_liquidity: '流動性の総計',
  my_shares: '保有額',
  token: 'トークン',
  enter_token_address: 'トークンアドレスの入力',
  remove: '除く',
  select: 'トークンを選択する',
  select_token: 'トークンを選択する',
  total_fee: '総コスト率',
  start_at: 'で開始する',
  end_at: 'で終了',
  ended: '終了している',
  pending: 'ペンディング',
  rewards_per_week: '毎週のリワーディング総額',
  apr: '年率換算',
  total_staked: 'ステーキングの合計金額',
  unclaimed_rewards: '未受領のリワード',
  claim: 'クレーム',
  claim_all: '全てクレームする',
  stake: 'ステーキング',
  unstake: 'ステーキングの取り消し',
  your_shares: '保有額',
  cancel: '取り消す',
  days: '日後',
  slippageCopyForMobile:
    'スリッページとは、他の取引が先に約定した結果、期待したものと実際に得られたものとの差のことです。',
  slippageCopy:
    'スリッページとは、他の取引が先に約定した結果、期待したものと実際に得られたものとの差のことです。',
  swapCopy:
    '交換取引とは、第1選択トークンと第2選択トークンを交換することである。<br> 最も流動性が高く、取引コストが低いプールを使用します。',
  addTokenCopy: 'NEP-141 トークンを追加する。',
  farmRewardsCopy: 'これは、実績ではなく、価格に基づいた指標値です。',
  you_do_not_have_enough: '足りません',
  is_not_exist: '存在しません',
  must_input_a_value_greater_than_zero:
    '0より大きい値を入力する必要があります。',
  no_pool_available_to_make_a_swap_from: 'どのプールも提供できません',
  for_the_amount: 'の量です',
  no_pool_eng_for_chinese: 'トランザクションの',
  is_not_a_valid_swap_amount: 'スワップ金額の誤り',
  not_nep_address:
    '入力されたアドレスはNEP-141のアドレスではありません。ご確認の上、再入力してください。 他のメインネットワークコントラクトであれば、レインボーブリッジでブリッジ処理を行います。',
  not_correct_address:
    '入力されたアドレスが正しくありません。確認後、再度入力してください。',
  pool_id: 'プールのID',
  more_pools: 'プールをもっと見る',
  my_watchlist: '私のコレクション',
  h24_volume: '24時間取引量',
  volume: '取引量',
  hide_low_tvl_pools: '低ロックアッププールを隠す',
  hide_low_tvl_pools_mobile: '低ロックアッププールを隠す',
  my_watchlist_copy: 'ブックマークされたプールはここに表示されます',
  language: '言語',
  deposit_to_add_liquidity: 'トークンを預けて流動性を高める',
  slip_warn: '注意：受け取れる最低金額を確認してください',
  slip_invalid: '有効な値を入力してください',
  reward_tokens: 'リワードトークン',
  detail_tip: '詳細',
  no_data: 'データなし',
  attention: 'ご注意ください',
  live: '実行',
  ended_search: '検索の終了',
  my_farms: 'あなたのファーム',
  sort_by: '並び替え',
  your_farms: 'あなたのファーム',
  new: '最新',
  unstake_tip_t: '未受領のリワードがある...',
  unstake_tip_m:
    'ステーキングのキャンセルにより、同じペアのアクティブおよび非アクティブのすべてのファームからすべてのステーキングが取り消されます。',
  unstake_tip_b: 'ステーキングをキャンセルしますか？',
  value_rewards: 'リワード',
  stake_unstake_tip:
    'ステーキングやステーキングをキャンセルすると、自動的にリワードが回収されます',
  over_tip: 'ガスフィーの最適化のため、一度に4トークンまで引き出しが可能です',
  no_token_tip: '出金可能なトークンはありません',
  getToken_tip:
    '今すぐリワードやステーキングトークンを請求することができます。',
  in_farm: 'ファームの中で',
  price_impact: '価格への影響',
  roi_calculator: 'ROI計算機',
  lp_staked: 'リキッドトークンのステーキング',
  usd: '米ドル',
  lp_token: '流動性トークン',
  stake_for: 'ステーキング時間',
  day_1: '1日',
  day_2: '7日',
  day_3: '30日',
  day_4: '90日',
  cur_apr: 'ROI',
  reward_token: 'リワードトークン',
  get_lp_token: '流動性トークンへのアクセス',
  calculate_roi: 'ROI計算機',
  rewards_claimed: '受領可能なリワードあり',
  value_rewards_token: 'リワードトークンの価値',
  all: 'すべて選択',
  all_5: '一度に4種類までのトークン',
  more_than: '0.01以上の数値を入力してください。',
  less_than: '20未満の数字を入力してください',
  no_valid: '有効な番号を入力してください',
  lp_fee: '流動性供給者',
  referral_fee: 'リファラルフィー',
  protocol_fee_referral_fee: 'プロトコル料金と紹介料',
  total_fee_create: 'トータルコスト',
  ref: 'REF',
  are_you_sure: '確定しますか',
  price_impact_is_about: '価格への影響は約',
  yes_swap: '確定、スワップします',
  input_greater_than_available_shares: '入力が利用可能なシェアより大きい',
  auto_router: 'トランザクションルート',
  optimal_path_found_by_our_solution: '私たちが見つけた最適のルート',
  make_sure_you_understand_what_you_do: '現在行っていることをご確認ください',
  filter_by: 'フィルタリング',
  allOption: '全て',
  stablecoin: 'ステーブルコイン',
  near_ecosystem: 'Nearエコシステム',
  bridged_tokens: 'ブリッジされたトークン',
  gaming: 'ゲーム',
  nft: 'NFT',
  bridge: 'ブリッジング　まで／から',
  no_result: 'ファームが見つかりませんでした',
  multiple: '倍率',
  default: 'デフォルト',
  create: '作成',
  select_a: '1つ選択してください',
  wallet: 'ウォレット',
  to_use_ref_finance: '{appName}を利用すると',
  not_supported: '非対応',
  installed: 'インストール済み',
  installe_now: '今すぐインストール',
  extension: 'プラグイン',
  first_time_using_ref: '初めて{appName}を使用する',
  learn_more: 'もっと見る',
  install_sender_now: '今すぐSenderをインストールする',
  connect_to_dapps_with_one_click: 'ワンクリックでdAppに接続',
  install: 'インストール',
  Connecting: '接続中',
  check_sender_wallet_extension: 'Sender walletプラグインをご確認ください。',
  having_trouble: '問題点は？',
  go_back: '戻る',
  web: 'Web',
  Type: 'タイプ',
  click_to_view: '詳細はこちら',
  transaction_failed: '失敗したトランザクション',
  wallet_vi: ' ',
  value: '額',
  usd_value: 'ドル換算額',
  initialize_account_tip: 'Please initialize your account.',
  support_ledger_tip:
    'Ledgerの設計によると、メモリの制限のため、Ledgerの台帳が大口取引に対応できない（自動ルーティングなど:複数のプールにまたがって同時に取引する）。 起動後,Ledgerをサポートする台帳は、トランザクションを次のように制限します。最もシンプルな形で（価格向上に寄与しない）。そのため、それなりの規模のコントラクトを結ぶことが可能です。',
  start: 'スタート',
  max: '最大',
  ref_account_balance_tip: 'モビリティの追加/削除でエラーが発生したようです。',
  ref_account_tip_2: 'REFのアカウントにトークンがある場合',
  ref_account_tip_top: 'お客様のREFアカウントにトークンを反映しております',
  click_here: 'ここをクリック',
  to_recover_them: '修復',
  ref_account_tip_3:
    'REFアカウントからトークンを引き出し、自分のNEARウォレットへ送金',
  aurora_account_tip_4:
    'マッピングアカウントからNEARウォレットにトークンを引き出すには、選択して引き出してください',
  buy: '買う',
  sell: '卖',
  rate: 'レート',
  name: '名前',
  diff: '差分',
  best: '一番',
  awesomeNear_verified_token: 'AwesomeNear検証済みトークン',
  pool_fee_apr: 'Pool fee APY',
  ref_account_balance_tip_mobile: 'REFアカウントにトークンがあります。',
  click: 'クリック',
  to_recover: '回復する。',
  rewards_week: 'Rewards/week',
  rewards: 'Rewards',
  claimed_Rewards: 'Claimed Rewards',
  POOL: 'プール',
  lp_Token: 'LP Tokens',
  booster: 'Booster',
  append: 'Append',
  farm: 'Farm',
  status: 'Status',
  Rewards: 'Rewards',
  free: 'Free',
  lp_tokens: 'LP tokens',
  connect_to_wallet: 'Connect Wallet',
  slash_policy_content:
    'Each seed has its own slash rate. And it will decreases linearly over time until be 0 at the unlock time of this CD Account.',
  not_expired: 'Not expired',
  accept_pay_slash_tip: 'I accept to pay slash',
  i_will_pay: 'I will pay',
  lp_token_slash: 'LP token exit fee.',
  expired: 'Expired',
  all_4_v2: '4 tokens/time',
  more_than_seed: 'Input must be greater than or equal to ',
  how_to_earn_more: 'How to earn more?',
  lock_your_lp_tokens_with_booster: 'Lock your LP tokens for boosted rewards',
  unstaked_anytime_no_booster: 'Unstaked anytime, no booster',
  locking_stake: 'Lock-up staking',
  change_to_lock: 'Change to Lock-up staking',
  estimated_rewards: 'Estimated rewards',
  final_booster: 'Final Booster',
  existing_amount: 'Existing amount',
  append_amount: 'Append amount',
  will_be_able_to_unstaked_after: 'will be able to unstaked after',
  you_have: 'You have',
  reward_apr: 'Rewards APR',
  stake_min_deposit: 'Input must be greater than or equal to ',
  unlock: 'Unlock',
  exit_fee: 'Exit fee',
  end_locking_period: 'End of locking period',
  add_lp_tokens_tip:
    'You need LP tokens to stake into the corresponding farm. First, add liquidity to the pool to get LP tokens.',
  slash_tip: 'Exit fee = Exit fee rate * End of locking period * Unlock amount',
  nonBoosted: 'Non-boosted',
  exit_fee_tip: 'Estimated amount you would pay to break your lock-up period',
  forbiddenTip: 'This farm does not support this duration option',
  unstakeTip: 'Staking or unstaking will automatically claim your rewards.',
  endedFarmsUnstakeTip:
    'Unstaking will remove the stake from all active and pending farms of the same pair. ',
  comimg: 'Coming',
  appendTip: 'Cannot be earlier than current locking time',
  week: 'week',
  yours: 'Yours',
  boost: 'Boost',
  near: 'NEAR',
  eth: 'ETH',
  others: 'Others',
  stakeLove: 'Stake LOVE',
  unstakeLove: 'Unstake LOVE',
  get_love: 'Get LOVE',
  swap_successful: 'スワップが成功しました。 ',
  trading_successfull: '取引は成功しました。 ',
  available_to_stake: 'available to stake',
  your_assets: 'あなたの資産',
  connect_wallet: 'ウォレットを接続する',
  disconnect: '切断する',
  change: '変化する',
  connect: '接続',
  veTip: 'veLP tokens are not transferable, veLPT represent your voting power ',
  loveTip:
    'LOVE stands for Liquidity Of veToken. LOVE, like any NEP-141 token, is transferable and can be swapped, pooled, staked and farmed. LOVE represents the underlying liquidity of your veTokens',
  keep_ve: 'keep',
  months: 'months',
  month: 'month',
  lock_lp_tokens: 'Lock LP Tokens',
  get_lptoken: 'Get LP Tokens',
  duration: 'Duration',
  ve_lock_tip: 'Cannot be earlier than current unlocking date',
  get: 'Get',
  you_have_no_lp_share: 'You have no LP Tokens',
  lock: 'Lock',
  locked: 'Locked',
  available: 'Available',
  in: 'in',
  filter: 'Filter',
  options: 'options',
  ratio: 'Ratio',
  back: 'Back',
  confirm: 'Confirm',
  total: 'Total',
  type: 'Type',
  connect_to_near_wallet: 'Connect to NEAR Wallet',
  v1Legacy: 'Legacy',
  v2New: 'Classic-New',
  v2_new_farms: 'Classic farms update',
  migrate_now: 'Migrate Now!',
  v2_boost_tip:
    'The updated classic farms will support boosted farms. The Legacy farms will run dry of rewards on the <span class="font-bold">1st of August 2022</span>.',
  v2_boost_no_tip:
    'The Legacy farms will run dry of rewards on the <span class="font-bold">1st of August 2022</span>.',
  love: 'LOVE',
  Available_to_stake: 'Available to stake',
  you_staked: 'You staked',
  has_rewards_tip_in_v2:
    'Withdraw legacy rewards from <a rel="noopener noreferrer nofollow" href="/farms" class="text-sm text-greenColor cursor-pointer underline ml-1 hover:text-senderHot"> Legacy Farms</a>.',
  how_to_get: 'How to get?',
  get_booster: 'Get Booster',
  ended_farms: 'ended farms',
  boosted_farms: 'Boosted farms',
  your_farm: 'Your farm',
  your_boosted_farms: 'Your boosted farms',
  search_farms_by_token: 'Search farms by token',
  search_farms: 'Search farms',
  more_lock_ve_popup2: 'more ',
  left: 'left',
  create_pool: 'Create Pool',
  search_by_token: 'Search by token',
  your_power: 'Your Power',
  farm_has_boost_tip:
    'Your Power = Your staked LP Tokens * booster (by staking LOVE)',
  farm_no_boost_tip: 'Your Power = Your staked LP Tokens',
  more_than_a_simple_pool: 'More than a simple pool',
  ended_Farms: 'Ended Farms',
  vote_capital: 'VOTE',
  boostFarmTip: 'Get booster by staking LOVE',
  boosted: 'Boosted',
  love_staked: 'Staked LOVE',
  your_apr: 'Your APR',
  range_apr: 'Range or reference APR',
  no_pair_found: 'ペアが見つかりません',
  found_stable_pool_in_sauce: 'SAUCE に安定したプールが見つかりました',
  lp_tokens_locking: 'LP Tokens',
  you_currently_have: '現在持っている',
  scheduled_to_be_unlocked: '解禁予定',
  locking_more_lp_tokens: 'もっとロックする LP Tokens',
  will_mean_these: 'これらを意味します',
  lp_tokens_will_not_be_unlocked_until: 'LP Tokens までロック解除されません',
  "I_understand_that_I_won't_be_able_to_remove_my":
    '削除できないことを理解しています',
  until: 'それまで',
  add: '追加',
  finish: '終了',
  add_custom_network: 'カスタム ネットワークを追加',
  network_name: 'ネットワークネーム',
  rpc_name_taken_tip: 'ネットワークネームは既に使用されています',
  network_invalid: 'ネットワークが無効でした',
  fobidden_testnet_rpc_tip:
    'RPC サーバーのネットワーク (テストネット) は、このネットワーク (メインネット) とは異なります',
  no_support_testnet_rpc_tip:
    'Testnet はカスタム RPC の追加をサポートしていません',
  stable: 'Stable',
  limit: '指値',
  your_active_orders_will_appear_here: 'アクティブな注文はここに表示されます',
  your_history_orders_will_appear_here: '注文履歴はここに表示されます',
  farm_only: '農場のみ',
  please_confirm_this_transaction_on_ledger:
    'Ledgerでこのトランザクションを確認して下さい',
  limit_order: '指値注文',
  farm_stop_tip: 'このファームは停止されました.',
  pool_stop_tip: 'このプールは停止されました.',
  volume_24h: '24時間ボリューム',
  add_to_watchlist: 'ウォッチリストに追加',
  remove_from_watchlist: 'ウォッチリストから削除',
  create_order: '注文する',
  filled: '約定',
  canceled: 'キャンセルした',
  partially_filled: '部分的に約定',
  pool_composition: 'プールの構成',
  amount: '総額',
  h24_volume_bracket: '24時間ボリューム',
  fee_24h: '24時間手数料',
  orders: '注文',
  your_orders: 'ご注文',
  active: 'アクティブ',
  history: '履歴',
  you_sell: '売却',
  you_buy: '購入',
  fee_tiers: '手数料のティア',
  created: '注文した',
  executed: '約定した',
  actions: 'アクション',
  claimed_upper: 'クレーム',
  open_my_order: 'オープン',
  initial_order: '初期の注文',
  this_order_has_been_partially_filled: 'この注文は部分的に約定された',
  filled_via_swap: 'スワップで約定された',
  state: 'ステート',
  partially: '部分的',
  near_validation_error: 'Must have 0.5N or more left in wallet for gas fee.',
  near_min_validation_error:
    'Must have 0.2N or more left in wallet for gas fee.',
  no_positons_in_this_pool_yet: 'No positons in this pool yet',
  no_claimed_rewards_yet: 'No claimed rewards yet',
  out_of: 'out of',
  fee_Tiers: '手数料のティア',
  no_pool: 'プールなし',
  input_amount: 'インプット金額',
  update_range: '範囲アップデート',
  not_enough_balance: '残高不足',
  set_price_range: '設定価格帯',
  current_price: '現在の価格',
  invalid_range_tip:
    '無効な範囲が選択されました. 最低価格は最高価格より低くなければなりません.',
  maket_price_outside_single_only_tip:
    '成行価格が価格帯外です. シングルアセットの入金のみ.',
  min_price: '最低価格',
  max_price: '最高価格',
  min: '最低',
  out_of_range: '範囲外',
  in_range: '範囲内',
  unclaimed_fees: '請求されていない手数料',
  your_position_will_be: 'あなたのポジションは',
  at_this_price: 'この価格で',
  price_range: '価格範囲',
  positions: 'ポジション',
  position: 'Position',
  range: '範囲',
  login_risk_tip:
    'By checking this box and moving forward, you confirm that you fully understand the risks of using {appName}.',
  stable_pool: 'Stable Pool',
  market_rate: 'Market Rate',
  no_token_found: 'No token found',
  search_name_or_address: 'Search name or paste address...',
  token_address_invalid: 'The token address was invalid',
  price_impact_warning: 'Price Impact Warning',
  confirm_order: 'Confirm Order',
  you_Sell: 'You Sell',
  to_Buy: 'to Buy',
  at_Price: 'at Price',
  insufficient_balance: 'Insufficient Balance',
  limitTip: 'Your price is automatically set to the closest price slot',
  v2_pools: 'DCL Pools',
  v2_your_pool_introduction: 'Your discretized concentrated liquidity',
  v1_your_pool_introduction: 'Your liquidity in classic pools',
  estimate_value: 'Estimate Value',
  price: 'Price',
  '@price': '@Price',
  trades: 'Trades',
  time: 'Time',
  balances: 'Balances',
  asset: 'Asset',
  action: 'Action',
  market: 'Market',
  Maker: 'Maker',
  chart: 'Chart',
  refresh_data_to_continue: 'Please refresh the data to continue',
  refresh: 'Refresh',
  both: 'Both',
  All: 'All',
  Filled: 'Filled',
  assets: 'Assets',
  cancel_order: 'Cancel Order',
  instrument: 'Instrument',
  dex: 'Dex',
  limit_order_created: 'Limit Order Created',
  limit_order_filled: 'Limit Order Filled',
  classic_pools: 'Classic Pools',
  active_orders: 'Active Orders',
  your_liquidity_usd_value: 'Your Liquidity (USD value)',
  usage: 'Usage',
  holding: 'Holding',
  your_lp_tokens_and_shares: 'Your LP Tokens(Shares)',
  swapped: 'Swapped',
  dcl_pool: 'DCL Pool',
  classic: 'Classic',
  classic_farms: 'Classic Farms',
  locked_in: 'locked in',
  'deposit_near_tip_0.5': 'To deposit, keep at least 0.5 NEAR to cover gas fee',
  trade: 'Trade',
  earn_2: 'Earn',
  portfolio: 'Portfolio',
  more_2: 'More',
  liquidity_pools_2: 'Liquidity Pools',
  stable_pools: 'Stable Pools',
  pool_detail: 'Pool Detail',
  new_contract_deploy_tip:
    'A new contract has been deployed! Please remove your liquidity from the old contract',
  remove_will_automatically_claim:
    'Removing will automatically claim your unclaimed fees.',
  legacy_tip: 'Found unstaked LP tokens or rewards in',
  legacy_farms: 'Legacy Farms',
  all_farms: 'All Farms',
  your_farms_2: 'Your Farms',
  dcl_farms: 'DCL Farms',
  farm_type: 'Farm type',
  farm_2: 'Farm',
  to_claim: 'To Claim',
  liquidity_staked: 'Liquidity staked',
  dcl_pool_detail: 'DCL Pool Detail',
  reward_range: 'Reward Range',
  reward_range_tip: 'Farm reward within this range',
  ending_soon: 'Ending soon',
  farm_ended_tip: 'This farm has ended.',
  farm_will_ended_tip: 'This farm will end soon.',
  new_farm: 'New Farm',
  is_coming: 'is coming',
  est_apr: 'Est. APR',
  farming: 'Farming',
  unavailable: 'Unavailable',
  hide: 'Hide',
  show: 'Show',
  your: 'Your',
  max_apr: 'Max.APR',
  you_can_earn_tip: 'Farm available, farm APR up to',
  you_can_earn_current_tip:
    'Your current staked farm ended, and new farm is coming, est. APR is',
  go_new_farm: 'Go New Farm',
  go_farm: 'Go Farm',
  in_ended_farm: 'in ended farm',
  staked: 'Staked',
  in_farm_3: 'in farm',
  estimation: 'Estimation Value',
  this_staked_tip: 'This NFT has been staked',
  dcl_liquidity: 'DCL Liquidity',
  classic_liquidity: 'Classic Liquidity',
  will_appear_here_tip: 'Your liquidity positions will appear here.',
  dcl_will_appear_here_tip: 'Your DCL liquidity positions will appear here.',
  classic_will_appear_here_tip:
    'Your Classic liquidity positions will appear here.',
  price_range_overlap_ratio: ' Price Range Overlap Ratio',
  real_time_executed_orders: 'real-time executed orders',
  real_time_executed_orders_tip:
    'When placing a sell order above market price or a buy order below market price using limit order function, {appName} will attempt to execute a swap-with-stop-point action first, and if there is any remaining amount, a limit order will be created to fill the rest.<br> Real-time executed orders refer to orders placed using the limit order function but executed through swapping. In the "History" section, you can view real-time executed orders between the earliest displayed limit order in History up to the present time.',
  swapped_history_order: 'Swapped',
  ledger_guide_tip_1:
    'To successfully use your Ledger wallet for transactions, the ',
  ledger_guide_tip_2: 'feature has been automatically activated.',
  ledger_guide_tip_3: 'Please be aware',
  ledger_guide_tip_quote: '"',
  support_ledger_tip_new: '"Support Ledger"',
  ledger_guide_tip_4:
    'that due to Ledger wallet constraints, the current rate provided by the swap function',
  ledger_guide_tip_5: 'may not be the best price.',
  ledger_guide_tip_6: '.',
  your_trade_route: 'Your Trade Route',
  markets: 'Markets',
  exchanges: 'Exchanges',
  output_est: 'Output (est.)',
  new_swap_order_tip:
    'The price is from the {appName} AMM offer and for reference only. There is no guarente that your limit order will be immediately filled. ',
  instants_swap: 'Instant Swap',
  swappped: 'Swapped',
  claimed: 'Claimed',
  executing_capital: 'Executing',
  trade_route: 'Trade Route',
  settings: 'Settings',
  no_trade_routes: 'No Trade Routes',
  steps_in_the_route: 'Steps in the Route',
  swap_chart_no_data: 'Not enough data for the chart right now.',
  last_updated: 'Last Updated',
  steps_in_the_route_zh: '',
  Burrow: 'Burrow',
  Supplied: 'Supplied',
  APY: 'APY',
  top_bin_apr: 'Top Bin APR (24h)',
  size: 'Size',
};
export default Object.assign(ja, ja_in_risks_page);
